<template>
  <div class="dashboard_container supervisor_db" aria-label="Instructor Dashboard Page Content">

    <div class="row">
      <div class="col-12 dashboard-content-section">

          <div class="row">
            <div class="col-xl-12 col-lg-7 col-md-12 col-sm-12 pr-0">
              <b-col cols="12 pl-0 pr-0 pg-lft-col">
                <b-row class="dashboard-row">
                  <b-col cols="12">
                    <div class="card ace_sec" aria-label="All Courses Section">
                      <div class="card-body carousel slide">
                        <div class="carousel-inner">
                          <div class="item active">
                            <template v-for="course in courses">

                              <div class="course ace_sec_txt" v-if="course.master">
                                <div class="course_name sec_hd"  data-toggle="tooltip" data-placement="top" :title="course.title" :aria-label="course.title">
                                  <div class="hd_ic">
                                    <span class="icon icon-course"></span>
                                  </div>
                                  <v-clamp class="title_txt" autoresize :max-lines="3">{{ course.title }}</v-clamp>
                                </div>
                                <div class="section_container">
                                  <template v-for="section in sections">
                                    <div class="obsr_sec">
                                      <div class="row obsr_row" @click="navigateToObservationReport(section)" v-if="course.uuid === section.masterCourseId">
                                        <div class="col-8 obsr_name">
                                          <v-clamp class="title_txt" autoresize :max-lines="2">{{ section.title }} </v-clamp>
                                        </div>
                                        <div class="col-4 obsr_action">
                                          <a href="javascript://" class="btn">Reports</a>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                  <div class="btm_lnk_container">
                                    <a href="javascript://" @click="navigateToAllObservationReport(course)">All Sections Reports</a>
                                  </div>
                                </div>
                              </div>

                            </template>
                              <div class="course ace_sec_txt" title="All Courses">
                                  <div class="course_name sec_hd" title="All Courses" aria-label="All Courses">
                                  <div class="hd_ic">
                                    <span class="icon icon-course"></span>
                                  </div>
                                  <v-clamp class="title_txt" autoresize :max-lines="3">All Courses</v-clamp>
                                </div>

                                <div class="btm_lnk_container">
                                  <a href="javascript://" @click="navigateToAllObservationReport(courses[0], userObj.customPermission.superSupervisorRole, !userObj.customPermission.superSupervisorRole)">All  Reports</a>
                                </div>
                              </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </div>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
  import '../../../assets/module/css/dashboard/dashboard.min.css'
  import { mapState, mapActions } from 'vuex'
  import AdviseeTracker from '../../adviseeTracker/components/./AdviseeTracker'
	import VClamp from 'vue-clamp'
  var staticQuickLinks = function () {
    var quickLinks = []
    return quickLinks
  }

  export default {
    name: 'supervisor-dashboard',
    components: {
      AdviseeTracker,
			VClamp
    },
    props: [],
    data: () => {
      return {
        page: 0,
        courses: [],
        sections : [],
        courseSections : {},
        lastPage: false,
        advisees: {total: 0},
        quickLinks: []
      }
    },

    async mounted () {
      if(this.userObj.customPermission && this.userObj.customPermission.superSupervisorRole){
          this.populateCoursesForSupersupervisor()
      }else{
          this.populateEnrolledCourses()
      }

      window.addEventListener('resize', this.handleWindowResize)
    },

    methods: {
      ...mapActions([
        'loadQuickLinks',
        'loadSupervisorCourses',
        'loadAdvisees',
        'loadSupersupervisorCourses'
      ]),

      handleWindowResize (event) {
        let routeName = this.$router.currentRoute.name
        if (routeName === 'supervisorDashboard') {
          this.populateEnrolledCourses()
        }
      },
      populateCoursesForSupersupervisor(){
        this.loadSupersupervisorCourses().then(res => {
          if (res && res.length > 0) {
            this.courses = res
            this.sections = res
          }
        })
      },
      populateEnrolledCourses () {
        const pagingOptions = {page: 0, count: 100}
        this.loadSupervisorCourses(pagingOptions).then(res => {
          if (res && res.length > 0) {
            this.courses = res
            this.sections = res
          }
        })
      },

      beforeDestroy: function () {
        window.removeEventListener('resize', this.handleWindowResize)
      },


      navigateToObservationReport (course) {
        this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_CLASS_SUMMARY', {})
        this.$store.commit('LOAD_COURSE_TOPICS', {})
        this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})

        let courseInfoMap = {}

        let instructorName = ''
        if (course.instructorNames.length > 0) {
          instructorName = course.instructorNames[0]
        }

        let courseInfoObj = {
          courseId: course.uuid,
          instructorName: instructorName,
          duration: course.duration
        }
        courseInfoMap[course.uuid] = courseInfoObj


        return this.$router.push({name: 'masterObservationReport', params: { uuid: course.uuid, courseInfoMap: courseInfoMap }})
      },
      navigateToAllObservationReport (course, allCourses, allmycourses) {
        this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_CLASS_SUMMARY', {})
        this.$store.commit('LOAD_COURSE_TOPICS', {})
        this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
        let courseIds = []
        let courseInfoMap = {}
        this.sections.forEach((item, i) => {
           if (course.uuid === item.masterCourseId || allCourses || allmycourses) {
             courseIds.push (item.uuid)

             let instructorName = ''
             if (item.instructorNames.length > 0) {
               instructorName = item.instructorNames[0]
             }

             let courseInfoObj = {
               courseId: item.uuid,
               instructorName: instructorName,
               duration: item.duration
             }
             courseInfoMap[item.uuid] = courseInfoObj
           }
        })

        return this.$router.push({name: 'masterObservationReport', params: { uuid: course.uuid, courseIds: courseIds, courseInfoMap: courseInfoMap, allCourses:allCourses }})
      }
    },

    computed: {
      ...mapState({
        'userObj': state => state.user.userObj,
        'links': state => state.dashboard.quickLinks
      })
    }
  }
</script>

<style scoped>
    .next {
        margin-top: 10%;
    }

    .icon-master {
        float: right !important;
        margin-top: 0px !important;
        margin-left: 0px !important;
    }
		.instructor_db_row .dashboard-content-section .dashboard_container {
			margin-left: 0px;
			padding: 0px;
			width: 100%;
		}
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/SupervisorDashboard.vue